// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageLoader_fullPage__YdxUg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60vh;
}

.PageLoader_inline__pKr82 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
}

.PageLoader_loadingText__VE-Zj {
  font-size: 1rem;
  font-weight: 500;
  color: #888;
  margin: 0;
  letter-spacing: 0.03em;
}`, "",{"version":3,"sources":["webpack://./src/components/PageLoader/PageLoader.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AACF","sourcesContent":[".fullPage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 60vh;\n}\n\n.inline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.loadingText {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #888;\n  margin: 0;\n  letter-spacing: 0.03em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullPage": `PageLoader_fullPage__YdxUg`,
	"inline": `PageLoader_inline__pKr82`,
	"loadingText": `PageLoader_loadingText__VE-Zj`
};
export default ___CSS_LOADER_EXPORT___;
